    // Кнопки
    // <ul class="tab-handlers" data-tab="handlers" data-tab-for="test"> 
    //     <li class="tab-handler active">
    //         <a class="tab-handler-link" rel="nofollow" href="#container-1">tab 1</a>
    //     </li>
    //     <li class="tab-handler">
    //         <a class="tab-handler-link" rel="nofollow" href="#container-2">tab 2</a>
    //     </li>
    //     <li class="tab-handler">
    //         <a class="tab-handler-link" rel="nofollow" href="#container-3">tab 3</a>
    //     </li>
    // </ul>
    // Вкладки
    // <ul class="tab-containers" data-tab="containers" data-tab-id="test">
    //     <li class="tab-container active" data-tab-container="container-1">
    //         <!-- -->
    //     </li>
    //     <li class="tab-container active" data-tab-container="container-2">
    //         <!-- -->
    //     </li>
    //     <li class="tab-container active" data-tab-container="container-3">
    //         <!-- -->
    //     </li>
    // </ul>

class Tabs {
    constructor( handlersWrap, containersWrap=null, options = {}) {

        if (!containersWrap) {
            let containersId = handlersWrap.dataset.tabFor
            containersWrap = document.querySelector(`[data-tab-id="${containersId}"]`)
        }
        if ( !(handlersWrap && containersWrap)) {
            this.error('bad parameters')
            return null
        }

        this.options = {
            activeClass: 'active'
        }
        this.options = {...this.options, ...options}

        this.handlers = Array.from( handlersWrap.querySelectorAll( '[href ^= "#"]' ) )
        this.relationship = {}
        this.activeId = ''

        this.handlers.forEach( handler => {
            let containerId = handler.getAttribute('href').slice(1)
            if (!containerId) return

            let container = containersWrap.querySelector(`[data-tab-container="${containerId}"]`)
            if (!container) return

            this.relationship[containerId] = {}
            this.relationship[containerId].handler = handler
            this.relationship[containerId].container = container
            if (!this.activeId && container.classList.contains( this.options.activeClass )) {
                this.activeId = containerId
            }
            if (this.activeId && container.classList.contains( this.options.activeClass ) && this.activeId !== containerId) {
                container.classList.remove( this.options.activeClass )
            }
        })
        if (!this.activeId) {
            this.activeId = Object.keys(this.relationship)[0]
            this.relationship[activeId].handler.classList.add( this.options.activeClass )
            this.relationship[activeId].container.classList.add( this.options.activeClass )
        }

        this.handlers.forEach(handler => {
            handler.addEventListener('click', (e) => this.toggleTab(e.target))
        })
    }

    error(error) {
        console.error(error)
    }

    toggleTab(handler) {
        let containerId = handler.getAttribute('href').slice(1)
        if ( !(containerId && this.relationship[containerId].container) ) return

        if (this.activeId) {
            this.relationship[this.activeId].handler.classList.remove( this.options.activeClass )
            this.relationship[this.activeId].container.classList.remove( this.options.activeClass )
        }
        this.relationship[containerId].handler.classList.add( this.options.activeClass )
        this.relationship[containerId].container.classList.add( this.options.activeClass )
        this.activeId = containerId
    }
}

export default Tabs